import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/logo.png" alt="Viviworks.IA" className="footer-logo-icon" />
              <span className="footer-logo-text">Viviworks<span className="logo-ai">.ai</span></span>
            </Link>
            <div className="footer-social">
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="YouTube">
                <img src="/youtube.png" alt="YouTube" className="social-icon" />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                <img src="/facebook.png" alt="Facebook" className="social-icon" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                <img src="/instagram.png" alt="Instagram" className="social-icon" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn">
                <img src="/linkedin.png" alt="LinkedIn" className="social-icon" />
              </a>
            </div>
          </div>

          <div className="footer-links">
            <h4 className="footer-title">Services</h4>
            <ul className="footer-list">
              <li><Link to="/services" className="footer-link">Développement web intelligent</Link></li>
              <li><Link to="/services" className="footer-link">Design graphic & Branding créatifs</Link></li>
              <li><Link to="/services" className="footer-link">Référencement et rédaction assistés par IA</Link></li>
            </ul>
          </div>

          <div className="footer-links">
            <h4 className="footer-title">Entreprise</h4>
            <ul className="footer-list">
              <li><Link to="/" className="footer-link">Accueil</Link></li>
              <li><Link to="/#about" className="footer-link">À propos</Link></li>
              <li><Link to="/realisations" className="footer-link">Nos projets</Link></li>
              <li><Link to="/#blog" className="footer-link">Blog</Link></li>
              <li><Link to="/#testimonials" className="footer-link">Témoignages</Link></li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4 className="footer-title">Contact</h4>
            <ul className="footer-list">
              <li><a href="mailto:contact@viviworks.ai" className="footer-link">contact@viviworks.fr</a></li>
              <li><a href="tel:+33685858383" className="footer-link">+33 6 85 85 83 83</a></li>
              <li className="footer-address">24-26 Arcadia Avenue, fin000<br/>Londres, Royaume-Uni, NJ 2JU</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-copyright">
          © 2024 Viviworks.IA - Tous droits réservés
        </p>
      </div>
    </footer>
  );
}

export default Footer;

